import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React, { Suspense } from 'react';
import AppBar from './components/AppBar';
import { LayoutSider } from './components/LayoutSider';
import { collapsedAtom } from './store';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
const {
  Header,
  Content
} = _Layout;
const LayoutWrapper = styled(_Layout)`
  height: 100vh;
  width: 100vw;
  background-color: var(--color-bg-1);
`;
const LayoutHeader = styled(Header)`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 60px;
  z-index: 100;

  &-hidden {
    height: 0;
  }
`;
export const BasicLayout = () => {
  const [collapsed] = useAtom(collapsedAtom);
  const {
    user
  } = useAuth();
  return /*#__PURE__*/React.createElement(LayoutWrapper, {
    hasSider: true
  }, user && /*#__PURE__*/React.createElement(LayoutHeader, null, /*#__PURE__*/React.createElement(AppBar, null)), /*#__PURE__*/React.createElement(_Layout, null, user && /*#__PURE__*/React.createElement(LayoutSider, null), /*#__PURE__*/React.createElement(Content, {
    style: {
      paddingTop: '76px',
      paddingLeft: collapsed ? '68px' : '240px',
      paddingRight: '20px'
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(_Spin, {
      delay: 200
    })
  }, /*#__PURE__*/React.createElement(Outlet, null)))));
};